import React, { FC, ReactElement } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import './style.scss';

interface Props {}
const TaxTopButton: FC<Props> = () => {
  const confirmEvt = () => {};

  return (
    <div className="_tax_bottom_description">
      {/* <div className="_item">
        주황색으로 표기된 금액은 PDF금액과 실제 연말정산 계산에 적용될 금액이 상이한 경우 입니다.
      </div>
      <div className="_item">
        (중도퇴사자, 중도입사자의 경우 근무기간 외의 금액이 제외되었을 수 있습니다.)
      </div>
      <div className="_item _t2">
        회색으로 표기된 내용은 부양가족으로 등록되어 있지 않거나 주민번호 매칭이 불가한 경우입니다.
      </div> */}
    </div>
  );
};

export default TaxTopButton;
